import React from "react";

/**
 * Inline activity spinner. Inherits `currentColor`, so it sits correctly on a
 * filled button or on a plain surface without being told which theme it is in.
 */
const Spinner = ({ className = "" }) => (
  <svg
    className={`animate-spin shrink-0 ${className}`}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2.5"
      opacity="0.25"
    />
    <path
      d="M21 12a9 9 0 0 0-9-9"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * Button content while a wallet request is pending. `aria-live` announces the
 * state change, since the label swap is the only cue a screen reader gets.
 */
export const PendingLabel = ({ children }) => (
  <span className="inline-flex items-center justify-center gap-2" aria-live="polite">
    <Spinner className="w-[18px] h-[18px]" />
    {children}
  </span>
);

export default Spinner;
